import request from "../../utils/request.js";

const loginBksApi = {
  /**
   * 获取图形验证码
   */
  getCaptcha() {
    return request.captcha("/platform-room/captcha");
  },
  /**
   * 商户(管家)登录
   * @param {Object} parameter
   */
  merchantUserLogin(parameter) {
    return request.post("/platform-room/bks/room/merchantUserLogin", parameter);
  },
  /**
   * 商户(管家)退出登录
   */
  merchantUserLogout() {
    return request.post("/platform-room/bks/room/merchantUserLogout");
  },
  /**
   * 发送验证码
   * @param {Object} parameter
   */
  sendVerify(parameter) {
    return request.post("/platform-room/bks/room/sendVerify", parameter);
  },
  /**
   * 用户修改密码
   * @param {Object} parameter
   */
  changeUserPassword(parameter) {
    return request.post("/platform-room/bks/room/changeUserPassword", parameter);
  },
  /**
   * 用户绑定信息
   * @param {Object} parameter
   */
  bindUserInfo(parameter){
	return request.post("/platform-room/bks/room/bindUserInfo", parameter);
  }
};

export default loginBksApi;
